import React from 'react';
import './OnScreenKeyboard.css';

type Props = {
  guessedLetters: string[];
  disabled?: boolean;
  onGuess: (letter: string) => void;
};

const letters = 'abcdefghijklmnopqrstuvwxyz'.split('');

function OnScreenKeyboard({ guessedLetters, disabled, onGuess }: Props): React.JSX.Element {
  return (
    <div className="keyboard">
      {letters.map((letter) => {
        const guessed = guessedLetters.includes(letter);
        return (
          <button
            key={letter}
            type="button"
            disabled={disabled || guessed}
            className={guessed ? 'guessed' : undefined}
            onClick={() => onGuess(letter)}
          >
            {letter}
          </button>
        );
      })}
    </div>
  );
}

export default OnScreenKeyboard;
